module.exports = __webpack_public_path__ + "img/PrintDefault.e1527c24.svg";